import { createBrowserHistory } from "history";
import { initialize, pageview } from "react-ga";
import { GA_TRACKING_CODES_BY_HOST } from "../constants/AppConstants";

const browserHistory = createBrowserHistory();

const hostname = window.location.hostname ?? "";
const host = hostname.split(".")[0];
initialize(GA_TRACKING_CODES_BY_HOST[host] ?? GA_TRACKING_CODES_BY_HOST.dev, {
  testMode: process.env.NODE_ENV !== "production",
  debug: false
});

let previousPath;

browserHistory.listen((location, _action) => {
  const path = location.pathname + location.search;

  if (path !== previousPath) {
    pageview(path);
  }

  previousPath = path;
});

export default browserHistory;
